export const KOUTO_EMBED_ROOT = 'kouto-embed-root';
export const BASE_URL = process.env.KOUTO_API_URL;
